import { ReactComponent as EnIcon } from '../../icons/en.svg';
import { ReactComponent as DeIcon } from '../../icons/de.svg';
import { MouseEventHandler } from 'react';
import classNames from 'classnames';
import './LangDropdown.scss';
import { useTranslation } from 'react-i18next';
import { Lang } from '../../core/types';
import HoverDropdown from '../HoverDropdown/HoverDropdown';
import Button from '../Button';

interface Props {
  className?: string;
}

const icons = {
  en: <EnIcon />,
  de: <DeIcon />,
};

const langs: Lang[] = ['de', 'en'];

const LangDropdown = ({ className = '' }: Props) => {
  const { i18n } = useTranslation();

  const onLangChange: (l: Lang) => MouseEventHandler<HTMLButtonElement> =
    (l: Lang) => (e) => {
      if (l === i18n.language) {
        e.preventDefault();
        return;
      }
      i18n.changeLanguage(l);
    };

  return (
    <HoverDropdown
      className='HoverDropdown--LangDropdown'
      arrow={false}
      trigger={
        <div
          className={`d-flex align-items-center justify-content-center text-uppercase px-0 ${className} LangDropdown__trigger`}
          tabIndex={-1}
          data-testid='lang-dropdown'
        >
          {icons[i18n.language as 'en' | 'de']}
        </div>
      }
    >
      <div className='text-center LangDropdown__menu d-flex justify-contenet-center align-items-center flex-column overflow-hidden'>
        {langs.map((l) => (
          <Button
            data-testid={`lang-btn-${l}`}
            styling='naked'
            key={l}
            onClick={onLangChange(l)}
            className={classNames(
              'd-flex justify-content-center align-items-center LangDropdown__item py-2 w-100',
              {
                'LangDropdown__item--active': l === i18n.language,
              }
            )}
          >
            {icons[l]}
          </Button>
        ))}
      </div>
    </HoverDropdown>
  );
};

export default LangDropdown;
